<template>
    <b-card style="border:none;">
        <b-container fluid>
            <b-row align-h="between" class="mt-4 pt-4">
                <b-col cols="4">
                    <h3>{{ this.$t('userGroupsPermissions') }}</h3>
                </b-col>
                <b-col class="text-right" cols="4">
                    <b-button @click="addUserGroup" variant="success">{{ this.$t('addNewUserGroup') }}</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-table
                    ref="table"
                    class="table"
                    style="cursor:pointer"
                    hover
                    :id="tableId"
                    :items="tableItems"
                    :fields="tableColumns"
                    responsive
                    no-border-collapse
                    @row-clicked="rowClicked"
                >
                </b-table>
            </b-row>
        </b-container>
    </b-card>
</template>

<script>
import _ from 'lodash';
import uuidV4 from 'uuid/v4';

export default {
    name: 'Permissions',
    data() {
        return {
            tableColumns: [
                {
                    label: this.$t('userGroup'),
                    key: 'groupName',
                    sortable: true,
                    thClass: 'table-point-th',
                    stickyColumn: true
                },
                {
                    label: this.$t('activeUsers'),
                    key: 'activeUsers',
                    sortable: true,
                    thClass: 'table-point-th',
                    stickyColumn: true
                }
            ],
            tableItems: [],
            userGroups: [],
            tableId: uuidV4()
        };
    },
    methods: {
        addUserGroup() {
            this.$router.push({name: 'add-permission'});
        },
        rowClicked(item) {
            this.$router.push({name: 'edit-permissions', params: {id: _.get(item,'id')}});
        },
        getPermissionGroups() {
            return this.axios
                .get(`/permission-groups`)
                .then(({data}) => {
                    return Promise.resolve(data);
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },
    created() {
        this.getPermissionGroups().then(userGroups => {
            this.userGroups = userGroups;
            this.tableItems = [];
            _.each(userGroups,userGroup => {
                this.tableItems.push({
                    groupName: this.$t(this.getGroupName(_.get(userGroup,'name'))),
                    activeUsers: _.get(userGroup,'users').length,
                    id: _.get(userGroup,'id')
                });
            });
        });
    }
};
</script>

<style scoped>
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "sitesTitle": "Lokasyonlar",
            "userGroup": "Kullanıcı Grubu",
            "activeUsers": "Aktif Kullanıcılar",
            "addNewUserGroup": "Yeni Kullanıcı Grubu Ekle",
            "userGroupsPermissions": "Kullanıcı Grupları & İzinler"
        },
        "en": {
            "sitesTitle": "Sites",
            "userGroup": "User Group",
            "activeUsers": "Active Users",
            "addNewUserGroup": "Add New User Group",
            "userGroupsPermissions": "User Groups & Permissions"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/Permissions.vue